import { graphql } from "@opensea/graphql"
import { useToggleWatchTokenFragment } from "./use-toggle-watch-token.fragment"

export const CurrencyWatchlistButtonFragment = graphql(
  `
  fragment CurrencyWatchlistButton on Currency {
    ...useToggleWatchToken
  }
`,
  [useToggleWatchTokenFragment],
)
